import {
  START_DRAG_ITEM,
  REMOVE_DRAG_ITEM,
  MOVE_ATTRIBUTE
} from '@/appComponents/workbench/targetDefinition/store/actions'

export default {
  props: {
    isDraggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canDropHere () {
      let dragFunc = this.$store.getters['workbench/canDraggingItemDropHere']
      return dragFunc ? dragFunc(this.definitionId, this.level) : true
    }
  },
  methods: {
    dragStartHandler (e) {
      e.dataTransfer.setData('text/plain', this.definitionId)
      this.$store.dispatch('workbench/' + START_DRAG_ITEM, this.definitionId)
      if (this.hoverOverPopover && this.hoverOverPopover.selectOption) {
        this.hoverOverPopover.selectOption()
      }
    },
    dragOverHandler (e) {
      // drag over event does not have access to dataTransfer store
      e.preventDefault()
      if (this.canDropHere) {
        e.dataTransfer.dropEffect = 'copy'
        e.currentTarget.classList.add('cursor-left')
      } else {
        e.dataTransfer.dropEffect = 'none'
      }
    },
    dragLeaveHandler (e) {
      e.preventDefault()
      e.currentTarget.classList.remove('cursor-left')
    },
    dropHandler (e) {
      e.preventDefault()
      if (this.canDropHere) {
        e.currentTarget.classList.remove('cursor-left')
        const data = e.dataTransfer.getData('text')
        this.$store.dispatch('workbench/' + MOVE_ATTRIBUTE, {
          droppedId: data,
          moveToId: this.definitionId,
          defType: this.defType
        })
      }
    },
    dragEndHandler (e) {
      e.preventDefault()
      this.$store.dispatch('workbench/' + REMOVE_DRAG_ITEM)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/components/mixins/DragAndDropHandlers.js